import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class FrightReport extends Component {

    constructor() {
        super();
        this.state = {
            stock: 'nav-item',

            reports: [],
            reportload: false,
        }
    }
    componentDidMount() {
        this.fetchdata()
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    tabledata=()=> {
        let retdata = null;
        if (this.state.reportload) {
            let count = 0;
            retdata = this.state.reports.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plateno}</td>
                    <td>{value.trip}</td>
                    <td>{value.startat}</td>
                    <td>{value.startkm}</td>
                    <td>{value.startfqty}</td>
                    <td>{value.starthandleempty}</td>
                    <td>{value.startperdiem}</td>
                    <td>{value.endat}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    fetchdata = () => {
        let params = (new URL(document.location)).searchParams;
        let fright_id = params.get("fright_id")
        this.setState({
            reports: [],
            reportload: false,
        })
        let baseurl = myconfig.frightreport;
        axios.post(baseurl, {
            id: fright_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    reports: res.data,
                    reportload: true,
                })

            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    render() {
        return (
            <>
                <Nav type="orderreport"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Fright Report</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={myconfig.urlwelcome}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Fright Report</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Fright Report</h3>
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive pt-3 px-2" style={{height: '500px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <th>#</th>
                                                <th>Truck #</th>
                                                <th>Trip Type</th>
                                                <th>Trip Start</th>
                                                <th>Millage</th>
                                                <th>Fuel QTY</th>
                                                <th>Handling Fee</th>
                                                <th>Pre Diem</th>
                                                <th>Trip End</th>
                                                </thead>
                                                <tbody>
                                                {this.tabledata()}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default FrightReport;
